import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";
import "./header.css";
import banner2 from "../../assets/bannerr/banner1.jpg";
import banner1 from "../../assets/bannerr/banner2.jpg";
import banner from "../../assets/bannerr/banner3.jpg"
import Nav from "../nav/Nav";
import Topheader from "../topheader/Topheader";
import Aboutmain from "../about/About";
import AboutUs from "../about/homeabout";
import Testimonials from "../Testimonial/Testimonial";
import OurClients from "../ourclient/Ourclient";
import Galleryy from "../gallery/Galleryy";
import Popup from "../Popup/Popup";
import Servicepage from "../Servicespage/Servicepage";
import Mainservicepage from "../mainservicepage/Mainservicepage";

const letterAnimation = {
  hidden: { opacity: 0, y: 10 },
  visible: (index) => ({
    opacity: 1,
    y: 0,
    transition: { delay: index * 0.05, duration: 0.3 },
  }),
};

// Fade-in animation for paragraph
const fadeInAnimation = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};

function AnimatedTitle({ text, isActive, isButton = false }) {
  return (
    <>
      {!isButton ? (
        <h1 className="banner-title">
          {text.split("").map((char, index) => (
            <motion.span
              key={index}
              custom={index}
              variants={letterAnimation}
              initial="hidden"
              animate={isActive ? "visible" : "hidden"}
            >
              {char === " " ? "\u00A0" : char}
            </motion.span>
          ))}
        </h1>
      ) : (
        <button className="banner-button">
          {text.split("").map((char, index) => (
            <motion.span
              key={index}
              custom={index}
              variants={letterAnimation}
              initial="hidden"
              animate={isActive ? "visible" : "hidden"}
            >
              {char === " " ? "\u00A0" : char}
            </motion.span>
          ))}
        </button>
      )}
    </>
  );
}

function Header() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [showPopup, setShowPopup] = useState(false);



  useEffect(() => {
    const bannerCarousel = document.getElementById("bannerCarousel");

    const handleSlide = (event) => {
      let newIndex = event.to;
      if (newIndex >= 3) newIndex = 0;
      if (newIndex < 0) newIndex = 2;
      setActiveIndex(newIndex);
    };

    bannerCarousel.addEventListener("slid.bs.carousel", handleSlide);

    return () => {
      bannerCarousel.removeEventListener("slid.bs.carousel", handleSlide);
    };
  }, []);

  const handleEnquiryClick = (e) => {
    e.preventDefault();
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  return (
    <section>
      {/* <Nav /> */}
      <div id="bannerCarousel" className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-inner">

          {/* Slide 1 */}
          <div className={`carousel-item ${activeIndex === 0 ? "active" : ""}`}>
            <img src={banner} className="d-block w-100 banner-img" alt="Slide 1" />
            <div className="carousel-caption">
              <AnimatedTitle text="NEW SKY PROPERTY & PROJECT PVT LTD
" isActive={activeIndex === 0} />
              <motion.p
                className="banner-text"
                variants={fadeInAnimation}
                initial="hidden"
                animate={activeIndex === 0 ? "visible" : "hidden"}
              >
                The company specializes in construction, property development, and real estate services, with a vision to create spaces 
                that combine quality, innovation, and sustainability.
              </motion.p>
              {/* <AnimatedTitle text="Learn More" isActive={activeIndex === 0} isButton={true} /> */}
            </div>
          </div>

          {/* Slide 2 */}
          <div className={`carousel-item ${activeIndex === 1 ? "active" : ""}`}>
            <img src={banner1} className="d-block w-100 banner-img" alt="Slide 2" />
            <div className="carousel-caption">
              <AnimatedTitle text="Real Estate Site" isActive={activeIndex === 1} />
              <motion.p
                className="banner-text"
                variants={fadeInAnimation}
                initial="hidden"
                animate={activeIndex === 1 ? "visible" : "hidden"}
              >
               With expert engineering, innovative techniques, and a focus on on-time delivery, we
                turn every blueprint into a lasting landmark of trust and excellence.
              </motion.p>
              {/* <AnimatedTitle text="Learn More" isActive={activeIndex === 1} isButton={true} /> */}
            </div>
          </div>

          {/* Slide 3 */}
          <div className={`carousel-item ${activeIndex === 2 ? "active" : ""}`}>
            <img src={banner2} className="d-block w-100 banner-img" alt="Slide 3" />
            <div className="carousel-caption">
              <AnimatedTitle text="Construction Site" isActive={activeIndex === 2} />
              <motion.p
                className="banner-text"
                variants={fadeInAnimation}
                initial="hidden"
                animate={activeIndex === 2 ? "visible" : "hidden"}
              >
                From residential plots and premium homes to commercial spaces and investment opportunities, we guide
                 our clients at every step with clarity and professionalism.
              </motion.p>
              {/* <AnimatedTitle text="Learn More" isActive={activeIndex === 2} isButton={true} onClick={handleEnquiryClick} /> */}
            </div>
          </div>

        </div>

        {/* Carousel Controls */}
        <button className="carousel-control-prev" type="button" data-bs-target="#bannerCarousel" data-bs-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#bannerCarousel" data-bs-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
      {/* <Aboutmain/> */}
      <AboutUs />
      <Servicepage/>
      {/* <Mainservicepage /> */}
      <Galleryy />
      <Popup />
      <OurClients />
      <Testimonials />

      <Popup show={showPopup} onClose={handleClosePopup} />

    </section>

  );
}

export default Header;
